// A UI boolean surviving the reload. Every access to the storage is guarded: in
// private browsing, or when the browser refuses site data, both reading and
// writing raise.
import { useCallback, useEffect, useState } from "react"

const read = (key, fallback) => {
  try {
    const stored = window.localStorage.getItem(key)
    if (stored === "true")  return true
    if (stored === "false") return false
  } catch (_error) {
  }
  return fallback
}

const usePersistedFlag = (key, fallback = true) => {
  const [value, setValue] = useState(() => read(key, fallback))

  useEffect(() => {
    try {
      window.localStorage.setItem(key, String(value))
    } catch (_error) {
    }
  }, [key, value])

  const toggle = useCallback(() => setValue(previous => !previous), [])

  return [value, toggle, setValue]
}

export default usePersistedFlag
